import { IEmailTemplateRegistration } from './registration';

export interface IEmailTemplateRegistrationUpdate {
    [key: string]: IEmailTemplateRegistration;
}
